import React from 'react'
import { useQueryClient } from 'react-query';
import { ManageProvider as ModuleProvider } from '@zimyo/manage';
import { getToken } from "../AppRedux/Actions";
import { useSelector } from 'react-redux';


const ManageProvider = ({ children }) => {

    const token = useSelector((state) => state.auth.authUser);
    const client = useQueryClient()

     return (
        <ModuleProvider queryClient={client} token={token} API_BASE_URL={window.env.API_BASE_URL} ASSETS_BASE_URL={"https://files.zimyo.work/files/attachments/"} HRMS_BASE_URL={window.env.HRMS_BASE_URL} mode={window.env.mode} LOGIN_BASE_URL={window.env.LOGIN_BASE_URL} >
            {children}
        </ModuleProvider>
    )
}

export default ManageProvider